var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:{
        [`icon-avatar-${_setup.size}`]: true,
        'rounded-circle': _setup.rounded,
        'rectangular': !_setup.rounded,
    },attrs:{"src":_setup.src,"alt":_setup.alt,"active":_vm.active,"disabled":_setup.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }